import React, { useEffect, useRef } from 'react';

import { useKitView } from 'containers/KitViewContext';
import { useKitWorkspace } from 'containers/KitWorkspaceStorage/context';
import { useKitTranslate } from 'common/components/kit-shared/useKitTranslate';
import { showToast } from 'utils/toasts';
import { ToastTypes } from 'common/types/toasts';
import ManageKitsPage from 'common/components/ManageKitsPage';
import MyAssembliesPopup from 'common/components/MyAssembliesPopup';

/**
 * Mounts the Manage Kits overlay page at the configurator root, gated by the
 * KitViewContext view-mode. ManageKitsPage portals into #modal-root itself, so
 * this just toggles it. Shared across all builds via app.tsx.
 */
const KitManageOverlay = () => {
  const { view, closeManageKits } = useKitView();
  const { storageAvailable } = useKitWorkspace();
  const t = useKitTranslate();

  // Tell the user once that a refresh will not keep their kits when localStorage
  // is blocked (private mode / embedded iframe). Non-blocking, fires a single
  // time per mount so it does not nag on every render.
  const warnedRef = useRef(false);
  useEffect(() => {
    if (!storageAvailable && !warnedRef.current) {
      warnedRef.current = true;
      showToast(ToastTypes.warning, t('texts.kits.toast.storageUnavailable'));
    }
  }, [storageAvailable, t]);

  if (view === 'manageKits') return <ManageKitsPage />;
  if (view === 'myAssemblies') return <MyAssembliesPopup onClose={closeManageKits} />;
  return null;
};

export default KitManageOverlay;
